import WarningIconTriangle from 'src/components/icons/warning-icon-triangle/';
import { MdButton } from '@antiqua-dls/vue-components';

import CloseIcon from '../close-icon';

export default {
  components: {
    MdButton,
    WarningIconTriangle,
    CloseIcon,
  },
  props: {
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
    labelKey: {
      type: String,
      default: '',
    },
    showVerifyButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    openEmailVerificationModal() {
      this.$emit('openEmailVerificationModal');
    },
    dismissBanner() {
      this.$emit('dismiss');
    },
  },
}
